// removed by extract-text-webpack-plugin
module.exports = {"container":"_1z57OqNYfB_r926BqpO3fL","divider":"_9p-0Pjp39wFSZMyGWPV7Y","signaturesLeft":"_2EYSxKIh7iqSrmVUqvrpdD","signaturesLeftDetail":"_19L3-yV1t9HQdd9_vd4tpv","signaturesLeftDetailWarning":"_1YqETPuX0Yujph79yBPf8g","toSign":"_1N6vrxpkG-6MFdonQzygvn","feaToSign":"_2KfPa6Lubyi740RGBeKvJa","buyButton":"ySlhljxwGCbuvpIuIlGZU"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Layout/Sidebar/styles.css
// module id = 2547
// module chunks = 0